<template>
  <div class="voucher-form">
    <div :class="'voucher-form__form' + (loading ? ' voucher-form__form--loading' : '')">
      <fieldset class="fieldset fieldset fieldset--inline fieldset--light">
        <m4-form-field
          v-if="formAction"
          v-model="voucherCode"
          @keydown="keydown"
          :default-placeholder="placeholder"
          :error="error"
        ></m4-form-field>
        <m4-tag
          v-if="alreadyAddedVoucherCode"
          :title="alreadyAddedVoucherCode"
          label="Voucher code:"
          :remove-url="removeCodeUrl"
        ></m4-tag>
      </fieldset>
      <m4-button v-if="formAction" @click="submit" tag="a" :variant="loading ? '' : 'info-outline'" size="md">
        <m4-loader v-if="loading" :width="2"></m4-loader>
        <span v-else>ADD</span>
      </m4-button>
    </div>
    <m4-toast v-if="successMessage" @closeToast="closeSuccessMessage" always-same-place>
      {{ successMessage }}
    </m4-toast>
  </div>
</template>
<script>
import inStyleguidist from "../../../utils/inStyleguidist";

export default {
  name: "M4VoucherForm",
  data() {
    return {
      voucherCode: "",
      loading: false,
      error: null,
      successMessage: this.toastSuccessMessage
    };
  },
  props: {
    placeholder: String,
    formAction: String,
    removeCodeUrl: String,
    toastSuccessMessage: String,
    alreadyAddedVoucherCode: String
  },
  methods: {
    keydown(e) {
      this.error = null;
      if (e.which === 13) {
        this.submit();
        e.preventDefault();
      }
    },
    closeSuccessMessage() {
      setTimeout(() => {
        this.successMessage = false;
      }, 600);
    },
    submit() {
      if (!this.voucherCode || this.voucherCode.trim() === "") {
        this.error = "Please fill in a voucher code";
        return false;
      }

      if (!this.loading) {
        this.loading = true;

        window
          .axios({
            method: inStyleguidist() ? "get" : "post",
            url: this.formAction,
            data: inStyleguidist()
              ? null
              : {
                  voucherCode: this.voucherCode
                }
          })
          .then((response) => {
            if (response.data !== undefined) {
              if (response.data.status === "ok") {
                if (response.data.location === "reload") {
                  location.reload();
                } else if (response.data.location) {
                  location.href = response.data.location;
                }
              } else if (response.data.status === "error") {
                this.error = response.data.errorMessage;
              }
            }
            this.loading = false;
          })
          .catch((error) => {
            if (
              error.response != undefined &&
              error.response.data != undefined &&
              error.response.data.errors != undefined
            ) {
              alert(error.response.data.errors[0].details);
            } else {
              alert(error);
            }
            this.loading = false;
          });
      }
    }
  }
};
</script>
